<template>
  <form class="login-form" @submit.prevent="signInBasic">
    <div class="card mb-0">
      <div class="card-body">
        <div class="text-center mb-3">
          <img
            src="@/assets/img/logos/logo_mini.png"
            class="h-72px"
            alt="Logo"
          />
          <h5 class="mt-1 mb-0">Portal de Relatórios</h5>
          <span class="text-muted">Entre com suas credenciais</span>
        </div>
        <div class="mb-3">
          <div class="form-control-feedback form-control-feedback-start">
            <input
              type="text"
              class="form-control"
              :class="{ 'is-invalid': v$.email.$errors.length }"
              placeholder="usuario@email.com"
              v-model="v$.email.$model"
            />
            <div class="form-control-feedback-icon">
              <i class="ph ph-envelope text-muted" />
            </div>
            <span
              v-if="
                (v$.email.required.$invalid || v$.email.email.$invalid) &&
                v$.email.$errors.length
              "
              class="invalid-feedback"
            >
              O campo deve conter um e-mail válido
            </span>
          </div>
        </div>
        <div v-if="userEthos" class="text-center mb-3">
          <button
            type="button"
            class="btn btn-dark"
            title="Login com Microsoft"
            :disabled="disableButton"
            @click="microsoftAuth"
          >
            <i class="ph ph-squares-four me-2"></i>
            Login com Microsoft
          </button>
        </div>
        <template v-else>
          <div class="mb-3">
            <div class="form-control-feedback form-control-feedback-start">
              <input
                type="password"
                class="form-control"
                :class="{ 'is-invalid': v$.senha.$errors.length }"
                placeholder="••••••••"
                v-model="v$.senha.$model"
              />
              <div class="form-control-feedback-icon">
                <i class="ph ph-lock text-muted" />
              </div>
              <span
                v-if="
                  (v$.senha.required.$invalid || v$.senha.minLength.$invalid) &&
                  v$.senha.$errors.length
                "
                class="invalid-feedback"
              >
                A senha deve ter pelo menos
                {{ v$.senha.minLength.$params.min }} caracteres
              </span>
            </div>
          </div>
          <div class="mb-3">
            <button
              type="submit"
              class="btn btn-dark w-100"
              title="Login"
              :disabled="v$.$invalid || disableButton"
            >
              <span v-if="disableButton">
                <i class="ph ph-spinner spinner" />
              </span>
              <span v-else>Login</span>
            </button>
          </div>
        </template>
        <div class="text-center" title="Esqueceu sua senha?">
          <router-link to="/password-recovery">
            Esqueceu sua senha?
          </router-link>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required, email, minLength } from '@vuelidate/validators'
import PATHS from '@/router/routesMap'

export default {
  name: 'Auth',

  setup() {
    return { v$: useVuelidate() }
  },

  data() {
    return {
      email: '',
      senha: '',
      userEthos: false,
      disableButton: false,
    }
  },

  watch: {
    email(newVal) {
      this.userEthos = newVal.includes('ethosvirtual')
    },
  },

  methods: {
    checkEthosEmail() {
      this.userEthos = this.email.includes('ethosvirtual')
    },

    async signInBasic() {
      if (!this.v$.$invalid) {
        this.disableButton = true
        try {
          await this.$store.dispatch('signInBasic', {
            email: this.email,
            senha: this.senha,
          })
          this.disableButton = false
          this.$router.push(PATHS.HOME)
        } catch (error) {
          this.disableButton = false
          if (error && error.message) {
            this.$root.$refs.notification.warning(error.message)
          } else {
            this.$root.$refs.notification.error(
              'Não foi possível se conectar ao servidor.',
            )
          }
        }
      }
    },

    async microsoftAuth() {
      try {
        this.disableButton = true

        const response = await this.$store.dispatch('getMicrosoftLink')

        if (response && response.link && response.link !== '') {
          this.disableButton = false
          window.location.href = response.link
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
          this.disableButton = false
        }
      } catch (error) {
        this.disableButton = false
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
  },

  validations() {
    return {
      email: {
        required,
        email,
      },
      senha: {
        required,
        minLength: minLength(6),
      },
    }
  },

  mounted() {
    if (localStorage.getItem('sessionError')) {
      this.$root.$refs.notification.warning(
        localStorage.getItem('sessionError'),
      )
      localStorage.removeItem('sessionError')
    }
  },
}
</script>
